import { config } from '../utils/constants/api.constants';

const keyManagementServices = (api) => {
  const createNewRequest = (data) => {
    console.log(data);
    let requestData = { reqId: data.appointmentId, keyName: 'appointmentId' };
    if (data.vinNumber) {
      requestData.reqId = data.vinNumber;
      requestData.keyName = 'vinNumber';
    }

    const keyMgtConfig = config.api.keyManagement;
    const apiUrl = `${
      keyMgtConfig.hostUrl + keyMgtConfig.api_v1 + keyMgtConfig.keyRequest
    }?${requestData.keyName}=${requestData.reqId}`;
    return new Promise((resolve, reject) => {
      api
        .post(apiUrl)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const cancelRequest = (reqId) => {
    const keyMgtConfig = config.api.keyManagement;
    const apiUrl = `${
      keyMgtConfig.hostUrl +
      keyMgtConfig.api_v1 +
      keyMgtConfig.keyRequest +
      '/' +
      reqId
    }/cancel`;
    return new Promise((resolve, reject) => {
      api
        .put(apiUrl)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const submitMarkReceived = (data) => {
    const keyMgtConfig = config.api.keyManagement;
    const apiUrl =
      keyMgtConfig.hostUrl +
      keyMgtConfig.api_v1 +
      keyMgtConfig.keyRequest +
      '/' +
      data.id +
      '/action/MARK_RECEIVED?noOfKeysReceived=' +
      data.numberOfKeys;
    return new Promise((resolve, reject) => {
      api
        .put(apiUrl)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const submnitOutkeyMarkReceived = (data) => {
    const keyMgtConfig = config.api.keyManagement;
    const apiUrl = `${
      keyMgtConfig.hostUrl + keyMgtConfig.api_v1 + keyMgtConfig.outKeys
    }/action/MARK_RECEIVED?vinNumber=${data.vinNumber}&appointmentId=${
      data.appointmentId
    }&noOfKeysReceived=${data.numberOfKeys}`;
    return new Promise((resolve, reject) => {
      api
        .put(apiUrl)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const submnitReadyToBePicked = (data) => {
    const keyMgtConfig = config.api.keyManagement;
    const apiUrl =
      keyMgtConfig.hostUrl +
      keyMgtConfig.api_v1 +
      keyMgtConfig.keyRequest +
      '/' +
      data.id +
      '/action/READY_TO_BE_PICKED';
    return new Promise((resolve, reject) => {
      api
        .put(apiUrl)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getKeyAuditTrail = (data) => {
    const keyMgtConfig = config.api.keyManagement;
    const apiUrl = `${
      keyMgtConfig.hostUrl + keyMgtConfig.api_v1 + keyMgtConfig.keyAuditTrail
    }?vinNumber=${data.vinNumber}&appointmentId=${data.appointmentId}&page=${
      data.page
    }&size=${data.size}`;
    return new Promise((resolve, reject) => {
      api
        .get(apiUrl)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    createNewRequest,
    cancelRequest,
    submitMarkReceived,
    submnitOutkeyMarkReceived,
    submnitReadyToBePicked,
    getKeyAuditTrail,
  };
};

export default keyManagementServices;
